import API from '../api'
import postUrl from '../post/paths'

export const createDispatchPlan = (dispatchPlan, userId) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.createDispatchPlan, { ...dispatchPlan }, { userId })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

// the files go as multipart parts, each one optional (tcDocuments and otherDocuments take several); the rest are query params
export const uploadVehicleDocuments = (
	dispatchPlanId,
	vehicleId,
	{ invoiceDocument, biltyDocument, ewayBillDocument, tcDocuments, otherDocuments, weighmentSlip } = {},
	{ originalSupplierInvoice, remarks } = {},
	userId
) =>
	new Promise((resolve, reject) => {
		const formData = new FormData()
		invoiceDocument && formData.append('invoiceDocument', invoiceDocument)
		biltyDocument && formData.append('biltyDocument', biltyDocument)
		ewayBillDocument && formData.append('ewayBillDocument', ewayBillDocument)
		;(tcDocuments ?? []).forEach((file) => formData.append('tcDocuments', file))
		weighmentSlip && formData.append('weighmentSlip', weighmentSlip)
		;(otherDocuments ?? []).forEach((file) => formData.append('otherDocuments', file))

		API.post(postUrl.uploadVehicleDocuments, formData, { userId, dispatchPlanId, vehicleId, originalSupplierInvoice, remarks, timeout: 300000 })
			.then((response) => resolve(response))
			.catch((error) => {
				reject(error)
			})
	})

// no body, everything goes as query params
export const bookInvoice = (userId, dispatchPlanId, vehicleId) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.bookInvoice, {}, { userId, dispatchPlanId, vehicleId })
			.then((response) => resolve(response))
			.catch((error) => {
				reject(error)
			})
	})
